import { Text } from "@mantine/core";

import type { JSX } from "react";

export function Header({ text }: { text: string }): JSX.Element {
    return (
        <Text fw="var(--mantine-font-weight-heavy)" c="dark.1">
            {text}
        </Text>
    );
}
